export const StatusDot = ({ status = 'info', pulse = false, size = 'sm' }) => {
  const sizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-2.5 h-2.5',
    lg: 'w-3 h-3'
  };

  const colorClasses = {
    healthy: 'bg-[var(--nexus-success)]',
    active: 'bg-[var(--nexus-success)]',
    degraded: 'bg-[var(--nexus-warning)]',
    critical: 'bg-[var(--nexus-danger)]',
    info: 'bg-[var(--nexus-info)]',
    live: 'bg-[var(--nexus-accent)]',
    idle: 'bg-[var(--nexus-text-muted)]',
    processing: 'bg-[var(--nexus-accent)]',
    warning: 'bg-[var(--nexus-warning)]',
    success: 'bg-[var(--nexus-success)]',
    danger: 'bg-[var(--nexus-danger)]',
  };

  const color = colorClasses[status.toLowerCase()] || colorClasses.info;

  return (
    <span className="relative inline-flex items-center justify-center">
      <span className={`rounded-full ${sizeClasses[size]} ${color}`}></span>
      {pulse && (
        <span className={`absolute rounded-full ${sizeClasses[size]} ${color} animate-nexus-pulse-dot opacity-40`}></span>
      )}
    </span>
  );
};
